import React from "react";

const About = ({ skillArea }) => {
  return (
    <section className="about" aria-labelledby="about-title">
      <div className="container">
        <div className="about-grid">
          <div>
            <div className="section-head">
              <h2
                id="about-title"
                dangerouslySetInnerHTML={{
                  __html: skillArea?.about_html,
                }}
              ></h2>
            </div>

            <div
              className="about-prose"
              dangerouslySetInnerHTML={{
                __html: skillArea.formatted_intro_body,
              }}
            ></div>
          </div>

          <aside className="who-card" aria-labelledby="who-title">
            <h3 id="who-title">Who these courses are for</h3>
            <div
              dangerouslySetInnerHTML={{ __html: skillArea?.target_audience }}
            ></div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default About;
